(function (Drupal, once) {
  'use strict';

  // Rechargement serveur suite à un échec de validation FormAPI (ex :
  // validateurs PHP custom du module grtgaz_webform, qui s'exécutent après
  // la validation HTML5 côté client). `aria-invalid="true"` est posé par le
  // core Drupal (RenderElementBase::setAttributes()) sur tout champ en
  // erreur, quel que soit son type : c'est le sélecteur le plus robuste.
  //
  // Le cas de la validation HTML5 côté client (attribut required, formulaire
  // avec novalidate) est traité séparément dans
  // Drupal.behaviors.nousContacter (javascripts/scripts.js), via
  // form.reportValidity() sur les formulaires .needs-validation.
  Drupal.behaviors.webformScrollToError = {
    attach: function (context) {
      once('webform-scroll-to-error', '.webform-submission-form', context).forEach(function (form) {
        var invalidField = form.querySelector('[aria-invalid="true"]');

        if (!invalidField) {
          return;
        }

        invalidField.scrollIntoView({behavior: 'smooth', block: 'center'});
        invalidField.focus({preventScroll: true});
      });
    }
  };
})(Drupal, once);
